import axiosClient from 'axios';
import https from 'https';
import {isEmpty} from "../components/helpers/helpers";


const $httpInSSR = (auth_token, fingerprint) => {
    var instance = axiosClient.create();

    instance.defaults.baseURL = process.env.NEXT_PUBLIC_API_BASE_URL;
    instance.defaults.headers['Client-Token'] = '598eec18374b5';
    instance.defaults.headers['post']['Content-Type'] = 'application/x-www-form-urlencoded';


    if (auth_token) {
        instance.defaults.headers['Auth-Token'] = auth_token
    }

    if (!isEmpty(fingerprint)) {
        instance.defaults.headers['Session'] = fingerprint;
    }

    if (process.env.NODE_ENV === 'development') {
        const httpsAgent = new https.Agent({
            rejectUnauthorized: false,
        })

        instance.defaults.httpsAgent = httpsAgent
    }

    return instance;
};

export {$httpInSSR};